export { Ccontainerskeleton } from './Ccontainerskeleton';
export type { CcontainerskeletonProps } from './Ccontainerskeleton';

